import { render, staticRenderFns } from "./VVirtualDataTable.vue?vue&type=template&id=51465342&scoped=true"
import script from "./VVirtualDataTable.vue?vue&type=script&lang=js"
export * from "./VVirtualDataTable.vue?vue&type=script&lang=js"
import style0 from "./VVirtualDataTable.vue?vue&type=style&index=0&id=51465342&prod&lang=less&scoped=true"
import style1 from "./VVirtualDataTable.vue?vue&type=style&index=1&id=51465342&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51465342",
  null
  
)

export default component.exports